export interface Lawyer {
    slug: string;
    name: string;
    title: string;
    tag: string;
    descriptions: string[];
    career: string[];
    introduction: string;
    careerDetails: string[];
    education: string[];
    qualifications: string[];
    performance?: string[]
}

export const LAWYERS: Lawyer[] = [
    {
        slug: "cho-keunho",
        name: "조 근 호",
        title: "대표 변호사",
        tag: "고등검찰청 검사장",
        descriptions: ["제 36대 법무연수원장", "민정수석실"],
        career: ["제 36대 법무연수원장", "민정수석실", "신세계그룹 사외이사", "현대카드 감사", "하나투어 사외이사"],
        introduction: "조근호 대표 변호사는 기업의 대규모 채권 회수, 강제집행 및 경영 리스크 관리 분야에서 법률 자문 및 소송 업무를 총괄하고 있습니다. 검찰 고위직 및 주요 대기업 감사·사외이사를 역임하며 쌓은 폭넓은 경험을 바탕으로, 복잡한 기업 간 분쟁과 대량 채권 관리에 있어 최적의 법률 솔루션을 제공합니다.",
        careerDetails: ["現 채권도시 법률사무소 대표변호사", "HM company 대표이사", "신세계그룹 사외이사", "현대카드 감사", "하나투어 사외이사", "디지털포렌식 산업포럼 회장", "황조근정훈장", "제36대 법무연수원 원장", "부산고등검찰청 검사장", "사법연수원 부원장", "민정수석실"],
        education: ["서울대학교 법학과 졸업"],
        qualifications: ["변호사"]
    },
    {
        slug: "hwang-ingyu",
        name: "황 인 규",
        title: "대표 변호사",
        tag: "검찰청 부천지청장",
        descriptions: ["인천지방검찰청 부천지청장", "의정부지검 차장"],
        career: ["의정부지방검찰청 차장", "CNCITY에너지 대표이사 회장", "한국형사소송법학회 고문", "채권도시 법률사무소 대표변호사"],
        introduction: "황인규 대표 변호사는 기업 법무, 형사 소송 및 채권 관리 분야에서 자문 업무를 수행하고 있습니다. 오랜 검사 재직 경험과 더불어 CNCITY에너지 대표이사 회장으로서 기업을 직접 경영한 실무 노하우를 보유하고 있습니다. 이러한 입체적인 경험을 결합하여, 법률과 기술, ESG 철학을 접목한 건전하고 생산적인 채권 회수 솔루션을 제공합니다.",
        careerDetails: ["現 채권도시 법률사무소 대표변호사", "CNCITY에너지 대표이사 회장", "4차 산업혁명융합법학회 부회장", "한국형사소송법학회 고문", "인천지방검찰청 부천지청장", "의정부지방검찰청 차장", "대전지검 서산지청장", "인천지검 형사4부장"],
        education: ["미국 Stanford Law School (Visiting Scholar)", "서울대학교 법학과 졸업"],
        qualifications: ["변호사"]
    },
    {
        slug: "park-hodong",
        name: "박 호 동",
        title: "대표 변호사",
        tag: "대기업 법률자문",
        descriptions: ["SKC 주식회사 사내변호사", "해외 제약기업 법률자문"],
        career: ["SKC 주식회사 사내변호사", "법무법인 BHSN 구성원 변호사", "법무법인 혜화 구성원 변호사", "TY & PARTNERS 법률사무소 변호사", "일본어(JLPT 1급) 및 공인 영어(IELTS C1)"],
        introduction: "박호동 변호사는 대기업 사내변호사 및 김·장 법률사무소 출신 변호사가 설립한 헬스케어 분야 1위 로펌 등을 거치며 기업 법무, 노사 분쟁, 민·형사 및 행정 소송 전반에 걸쳐 자문 등 업무를 수행하고 있습니다. 다국적 제약사 및 주요 공기업의 법률자문을 전담한 바 있으며, 특수 가처분 소송, 기업 내 부당해고 및 노동조합 관련 노동 분쟁, 각종 형사 재판에서 다수의 무죄 및 승소 판결을 이끌어낸 실무 경험을 보유하고 있습니다.",
        careerDetails: ["現 채권도시 법률사무소 변호사", "법무법인 BHSN 변호사", "법무법인 혜화 변호사", "JOY&PARTNERS 법률사무소 변호사", "TY&PARTNERS 법률사무소 변호사", "SKC 주식회사 사내변호사"],
        performance: ["화이자, 엘러간, 박스터, 다케다 등 다국적 제약기업 법률자문 등 수행", "한국전력, 국민연금공단 등 공기업 및 일반기업 법률자문 수행", "형사소송 방어 및 무죄 판결 12건, 집행유예·선고유예·항소심 감형 판결 도출", "노동조합 불법 쟁의행위 방어, 지노위·중노위 부당노동행위 및 부당해고 구제신청 등 노사 분쟁 자문 및 소송 수행", "성형외과 의사 부당해고 구제신청 관련 중노위 재심판정 취소소송 항소심 근로자성 인정 판결 도출", "프로그램사용중지가처분, 전직금지가처분, 집회금지가처분 등 기업 특수 가처분 소송 수행 및 인용 결정 도출", "수십억 원 규모의 기업 간 민사 소송 및 명도집행 등 강제집행 절차 수행"],
        education: ["고려대학교 법학전문대학원 졸업", "고려대학교 법학과 졸업"],
        qualifications: ["변호사"]
    },
    {
        slug: "park-hyejeong",
        name: "박 혜 정",
        title: "변호사",
        tag: "취약계층 법률구조",
        descriptions: ["법무법인 율정", "법무부 법률홈닥터"],
        career: ["법무부 법률홈닥터 변호사", "대한변호사협회 공익활동심사위원", "법무법인 율정 소속 변호사", "사회복지사 2급 및 국제통번역자격증", "우성원·아름해든집 인권위원"],
        introduction: `박혜정 변호사는 민사, 가사, 형사 및 행정 소송 전반에 걸쳐 송무 및 법률 자문 업무를 수행하고 있습니다. 법무부 법률홈닥터 변호사로 재직하며 취약계층을 위한 법률 구조 및 소송 지원을 전담하였고, 다수의 인권위원회 위원 및 대한변호사협회 공익활동심사위원으로 활동하며 현장 중심의 실무 감각을 축적하였습니다.

사회복지사 및 국제통번역 자격을 바탕으로 내국인뿐만 아니라 다문화 가정 및 외국인 의뢰인의 복잡한 가사·민사 분쟁에 있어 깊이 있는 분석과 체계적인 법률 솔루션을 제공합니다.`,
        careerDetails: ["現 채권도시 법률사무소 변호사", "대한변호사협회 공익활동심사위원", "박혜정법률사무소 변호사", "법무부 법률홈닥터 변호사", "법무법인 율정 소속 변호사", "우성원, 아름해든집, 한아름 인권위원"],
        performance: ["민사, 형사, 행정 사건 송무 및 가사 사건 법률 검토 수행", "법무부 소속 취약계층 대상 민·형사 및 행정 분쟁 법률 구조, 나홀로 소송 지원 총괄", "형사 국선변호인 활동 및 소송 서면 작성 수행", "사회복지시설 인권지킴이단 소속 현장 인권 침해 사례 조사 및 구제 자문", "다문화 가정 및 외국인 의뢰인 대상 민·가사 분쟁 법률 지원 및 상담 수행"],
        education: ["이화여자대학교 법학전문대학원 졸업 (석사)", "이화여자대학교 법학과 졸업"],
        qualifications: ["변호사", "사회복지사 2급", "국제통번역자격증"]
    },
    {
        slug: "lee-yeeun",
        name: "이 예 은",
        title: "변호사",
        tag: "대형 부동산신탁사",
        descriptions: ["법무법인(유) 엘케이파트너스 변호사", "㈜코람코자산신탁 사내변호사"],
        career: ["現 채권도시 법률사무소 변호사", "법무법인(유) 엘케이파트너스 소속변호사", "㈜코람코자산신탁 법무팀 사내변호사"],
        introduction: `이예은 변호사는 부동산, 금융, 공정거래 및 일반 기업 법무 분야에서 자문 및 송무 업무를 수행하고 있습니다.

코람코자산신탁 법무팀 사내변호사로 재직하며 부동산신탁, 리츠(REITs), 프로젝트파이낸싱(PF) 등 금융과 부동산이 결합된 분야의 계약 검토 및 법률 리스크 관리, 분쟁 대응 업무를 전담하였습니다. 법률전문가 활동 전 김·장 법률사무소 특허부서, 글로벌 홍보대행사 및 스타트업에서 기업의 브랜드 전략과 위기관리, 대외 커뮤니케이션 업무를 수행한 바 있습니다. 이러한 입체적인 실무 경험을 바탕으로 기업의 의사결정 구조 및 커뮤니케이션 전략에 대한 깊은 이해를 더하여 최적화된 법률 자문을 제공합니다.`,
        careerDetails: ["現 채권도시 법률사무소 변호사", "법무법인(유) 엘케이파트너스 소속변호사", "㈜코람코자산신탁 법무팀 사내변호사"],
        performance: ["관리형 토지신탁, 담보신탁, 처분신탁, 지역주택조합 및 신용대출금 자금관리대리사무 등 부동산신탁 관련 주요 계약 자문", "금융회사 자회사 출자 승인 관련 자문", "금융소비자 보호 관련 금융감독원 대응", "모회사-자회사 간 부당지원 등 공정거래법상 불공정거래행위 관련 자문", "분양계약 해제, 공사대금, 임대차, 일조권 침해 손해배상, 지역주택조합 분담금 반환, 용역대금 청구 등 민사소송 대응"],
        education: ["충북대학교 법학전문대학원 졸업", "이화여자대학교 독어독문학과·정치외교학과 졸업"],
        qualifications: ["변호사"]
    },
];